import React from 'react';

const StatsTables = ({ 
    sortiraniRadniciStats, 
    toggleSortRadnici, 
    ukupnoStatsDnevnica, 
    ukupnoStatsSumaRsd, 
    sortiraniDaniStats, 
    toggleSortDani, 
    prosekVozila, 
    formatirajDatum, 
    thStyle, 
    tdStyle, 
    stats 
}) => {
    return (
        <div style={{display: 'flex', gap: '30px', alignItems: 'flex-start'}}>
            <div style={{flex: 1.2}}>
                <h3 style={{color: '#7b1fa2', borderBottom: '2px solid #7b1fa2', paddingBottom: '5px'}}>Dnevnice po radniku</h3>
                <table style={{width: '100%', borderCollapse: 'collapse', backgroundColor: '#0a132b'}}>
                    <thead>
                        <tr>
                            <th style={thStyle} onClick={() => toggleSortRadnici('id')}>ID</th>
                            <th style={{...thStyle, textAlign: 'left'}} onClick={() => toggleSortRadnici('ime')}>Ime i Prezime</th>
                            <th style={thStyle} onClick={() => toggleSortRadnici('broj')}>Br. Dnevnica</th>
                            <th style={thStyle} onClick={() => toggleSortRadnici('suma')}>Ukupno RSD</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortiraniRadniciStats.map((r, i) => (
                            <tr key={i}>
                                <td style={tdStyle}>{r.id}</td>
                                <td style={{...tdStyle, textAlign: 'left'}}>{r.ime}</td>
                                <td style={{...tdStyle, fontWeight: 'bold', color: '#00ff00'}}>{r.broj}</td>
                                <td style={{...tdStyle, fontWeight: 'bold'}}>{parseFloat(r.suma || 0).toLocaleString('sr-RS')}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr style={{backgroundColor: '#162447', fontWeight: 'bold', borderTop: '2px solid #3366ff'}}>
                            <td style={tdStyle}>Σ</td>
                            <td style={{...tdStyle, textAlign: 'left'}}>UKUPNO ZA PERIOD:</td>
                            <td style={{...tdStyle, color: '#00ff00', fontSize: '16px'}}>{ukupnoStatsDnevnica}</td>
                            <td style={{...tdStyle, color: 'white', fontSize: '16px'}}>{ukupnoStatsSumaRsd.toLocaleString('sr-RS')} RSD</td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <div style={{flex: 1}}>
                <h3 style={{color: '#3366ff', borderBottom: '2px solid #3366ff', paddingBottom: '5px'}}>Vozila na terenu</h3>
                <table style={{width: '100%', borderCollapse: 'collapse', backgroundColor: '#0a132b'}}>
                    <thead>
                        <tr>
                            <th style={thStyle} onClick={() => toggleSortDani('datum')}>Datum</th>
                            <th style={thStyle} onClick={() => toggleSortDani('vozila')}>Broj vozila</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortiraniDaniStats.map((d, i) => (
                            <tr key={i}>
                                <td style={tdStyle}>{formatirajDatum(d.datum)}</td>
                                <td style={{...tdStyle, fontWeight: 'bold', color: '#00ff00'}}>{d.vozila} vozila</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr style={{backgroundColor: '#162447', fontWeight: 'bold', borderTop: '1px solid #3366ff'}}>
                            <td style={tdStyle}>Σ UKUPNO IZLAZAKA:</td>
                            <td style={{...tdStyle, color: '#00ff00'}}>{stats.po_danima.reduce((sum, d) => sum + d.vozila, 0)}</td>
                        </tr>
                        <tr style={{backgroundColor: '#0a132b', fontStyle: 'italic'}}>
                            <td style={tdStyle}>PROSEK DNEVNO:</td>
                            <td style={{...tdStyle, color: '#3366ff'}}>{prosekVozila} vozila</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
};

export default StatsTables;